import { Pagination, Segmented, Space, Switch, Table } from 'antd';
import { putApi } from 'apis';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
	SortBottomIcon,
	SortTopIcon,
	TableNextIcon,
	TablePreviousIcon,
} from 'utils/svgs';
import { toastText } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';
import { StaffCustomTableProps } from './type';

const CustomTable: FC<StaffCustomTableProps> = (props) => {
	const { Column } = Table;
	const {
		dataSource,
		handleTableChange,
		onShowSizeChange,
		isLoading,
		search,
		totalRecords,
		performSearchHandler,
		staffSegment,
		onStaffSegmentChange,
		onStatusChange,
		currentPage,
		pageSize,
		isSearchCancel,
		setSearch,
		setIsSearchCancel,
	} = props;

	const userPermissions = useSelector((state: any) => state?.userProfile);
	const loggedInUserId = userPermissions?.data?.id;
	const sortedDataSource = [
		...(dataSource?.filter((item: any) => item.userId === loggedInUserId) || []),
		...(dataSource?.filter((item: any) => item.userId !== loggedInUserId) || []),
	];

	const statusHandler = async (value: boolean, data: any) => {
		const finalData = {
			updateUserId: data?.userId,
			status: value,
		};

		try {
			await putApi('/user/staff-status-update', finalData);
			toastText('Staff status updated successfully', 'success');
			onStatusChange();
		} catch (error: any) {
			toastText(
				error.response?.data?.message ?? 'Something went wrong in staff status update',
				'error'
			);
		}
	};

	return (
		<>
			<div className={`${styles['body']} user-table-pagination`}>
				<SearchAndFilter
					performSearchHandler={performSearchHandler}
					searchValue={search}
					title={'Staff List'}
					isSearchCancel={isSearchCancel}
					setSearch={setSearch}
					setIsSearchCancel={setIsSearchCancel}
				/>

				<div className={styles['segment']}>
					<Segmented
						options={[
							{ label: 'Active', value: 'active' },
							{ label: 'Not Active', value: 'inactive' },
						]}
						value={staffSegment}
						onChange={(value) =>
							onStaffSegmentChange(value as 'active' | 'inactive')
						}
					/>
				</div>

				<Table
					rowKey={(record: any) => record?.userId}
					dataSource={sortedDataSource}
					pagination={false}
					loading={isLoading}
					onChange={handleTableChange}
					scroll={{ y: 'calc(100vh - 360px)' }}
					rowClassName={(record) =>
						record.userId === loggedInUserId ? styles.disabledRow : ''
					}
				>
					<Column
						title={<p style={{ padding: '0 10px' }}>User</p>}
						dataIndex="name"
						key="name"
						className="user-column bg-white"
						width={'20%'}
						sorter
						sortDirections={['ascend', 'descend', 'ascend']}
						render={(value: any) => (value ? value : '-')}
						sortIcon={({ sortOrder }) => {
							const isAscend = sortOrder === 'ascend';
							const isDescend = sortOrder === 'descend';

							return (
								<>
									<SortTopIcon fill={isAscend ? '#949494' : undefined} />
									<SortBottomIcon fill={isDescend ? '#949494' : undefined} />
								</>
							);
						}}
					/>

					<Column
						title="Role"
						dataIndex="roleName"
						key="roleName"
						className="bg-white"
						width={'15%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Email"
						dataIndex="email"
						key="email"
						className="bg-white"
						width={'25%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Staff Status"
						dataIndex="staffActive"
						key="staffActive"
						className="bg-white"
						width={'15%'}
						render={(value: boolean, data: any) => (
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
								}}
							>
								<Space>
									<Switch
										key={`${data.userId}-${value}`}
										checked={value}
										onChange={(checked) => statusHandler(checked, data)}
										disabled={
											data.userId === userPermissions?.data?.id ||
											!data.isVerified ||
											data.isAdmin
										}
									/>
								</Space>
							</div>
						)}
					/>
				</Table>

				<div className={styles['pagination__wrapper']}>
					<Pagination
						current={currentPage}
						pageSize={pageSize}
						showSizeChanger
						onChange={onShowSizeChange}
						total={totalRecords}
						itemRender={(page, type, originalElement) => {
							return (
								<div className={styles['pagination']}>
									{type === 'prev' ? (
										<button
											className={`${styles['pagination']} ${styles['pagination__button']}`}
										>
											<TablePreviousIcon />
											<p className={styles['pagination__previous']}>Previous</p>
										</button>
									) : type === 'next' ? (
										<button
											className={`${styles['pagination']} ${styles['pagination__button']}`}
										>
											<p className={styles['pagination__next']}>Next</p>
											<TableNextIcon />
										</button>
									) : (
										originalElement
									)}
								</div>
							);
						}}
					/>
				</div>
			</div>
		</>
	);
};

export default CustomTable;
